<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// The Terms screen is gone from Settings (STG-WEB-13: four read-only inputs
// nobody used). Old links land on the organisation's details; a named
// redirect keeps the :org param.
definePage({
  redirect: { name: '/(app)/[org]/settings/(organizations)/' },
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
  },
})
</script>

<template>
  <div />
</template>
